import type { CuratedItem } from "~types/types";
import {
    type IntegrityStatus,
    checkItemArrayIntegrity,
} from "~utils/moduleIntegrity";

interface StoryListDefaultIntegrityProps {
    items?: CuratedItem[] | [];
}

export default function integrityCheck({
    items,
}: StoryListDefaultIntegrityProps): IntegrityStatus {
    return checkItemArrayIntegrity(items);
}
